export default __webpack_public_path__ + "static/media/Quality.9d0e07f1.png";